import { FieldSchemaFormBuilderV2, SchemaFactoryV2 } from "@ucl/library";
import { MODEL_KEYS, FIELD_KEYS } from "@/constants";
import { CreditAuthorizationUpdateDTO } from "@/types/CreditAuthorizationUpdateDTO";

export const createCreditAuthorizationFormBuilder = (
  schemaFactory: SchemaFactoryV2
): FieldSchemaFormBuilderV2<CreditAuthorizationUpdateDTO> => {
  return (onValueChange, form, errors) => {
    const fields = [
      ...schemaFactory.buildModelSchema<CreditAuthorizationUpdateDTO>(
        MODEL_KEYS.CREDIT_AUTHORIZATION,
        onValueChange,
        form,
        errors,
        [FIELD_KEYS.CREDIT_AUTHORIZATION.DECISION], // Required fields
        {}
      ),
    ];

    return fields;
  };
};
